"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ZoomInOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M14 14h4a1 1 0 000-2h-4V8a1 1 0 00-2 0v4H8a1 1 0 000 2h4v4a1 1 0 102 0z"/><path d="M29.71 28.29L21.45 20A11 11 0 1020 21.45l8.25 8.26a1 1 0 001.42 0 1 1 0 00.04-1.42zM13 22a9 9 0 119-9 9 9 0 01-9 9z"/>';
var ZoomInOutlineSVG = function ZoomInOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.ZoomInOutlineSVG = ZoomInOutlineSVG;
ZoomInOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(ZoomInOutlineSVG);
exports.default = _default;